// @flow
import * as React from 'react';
import { parseQueryParams, removeQueryParams, stringifyQuery } from '../../../utils/queryParams';
import { useHistory, useLocation } from 'react-router-dom';
import { openSignUpModal } from '../../../redux/modules/modal';
import { useDispatch } from 'react-redux';

type Props = {|
    isLoggedIn: boolean,
|};

export const SignupAction = (props: Props) => {
    const { isLoggedIn } = props;
    const location = useLocation();
    const history = useHistory();
    const queryParams = parseQueryParams(location.search);
    const dispatch = useDispatch();
    React.useEffect(() => {
        if (queryParams.action === 'signup') {
            const query = removeQueryParams(queryParams, ['action']);
            const stringified = stringifyQuery(query);
            const newLocation = location.pathname + stringified ? '?' + stringified : '';
            !isLoggedIn && dispatch(openSignUpModal());
            history.push(newLocation);
        }
    }, [dispatch, isLoggedIn, location, queryParams, history]);

    return null;
};

export default SignupAction;
